<div class="container-fluid glb-popup">
	<h2> {{formTitle}}</h2>
	<p-toast [style]="{marginTop: '80px'}">
	</p-toast>


	<button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
		<i class="pi pi-times" aria-hidden="true"></i>
	</button>
	<hr>
	<div [formGroup]="form1" class="forms w-100 d-block">
		<div class="row m-0 advance-search-form">
			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2 d-block">
					<p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="locations" formControlName="locationIds" id="locationIds" defaultLabel="Select Location"
						optionValue="locationId" optionLabel="name" display="chip">
					</p-multiSelect>
					<label for="locationIds">Select Locations</label>
				</span>
			</div>

			<div class="col-lg-6">
				<span class="p-float-label my-2 me-2">
					<p-calendar inputId="arrivalStartDate" formControlName="arrivalStartDate" (onSelect)="onDateChange()" [style]="{'width':'100%'}">
					</p-calendar>
					<label for="arrivalStartDate">Arrival Start Date</label>
				</span>
			</div>
			<div class="col-lg-6">
				<span class="p-float-label my-2 me-2">
					<p-calendar #checkOutDateCal inputId="arrivalEndDate" formControlName="arrivalEndDate" [style]="{'width':'100%'}" [minDate]="minArrivalToDate" [defaultDate]="minArrivalToDate">
					</p-calendar>
					<label for="arrivalEndDate">Arrival End Date</label>
				</span>
			</div>
			<div class="col-lg-6">
				<span class="p-float-label my-2 me-2">
					<p-calendar inputId="saleStartDate" formControlName="saleStartDate" (onSelect)="onDateChange()" [style]="{'width':'100%'}">
					</p-calendar>
					<label for="saleStartDate">Sale Start Date</label>
				</span>
			</div>
			<div class="col-lg-6">
				<span class="p-float-label my-2 me-2">
					<p-calendar #checkOutDateCal inputId="saleEndDate" formControlName="saleEndDate" [style]="{'width':'100%'}" [minDate]="minSaleToDate" [defaultDate]="minSaleToDate">
					</p-calendar>
					<label for="saleEndDate">Sale End Date</label>
				</span>
			</div>
			<div class="col-lg-6">
				<span class="p-float-label my-2 me-2">
					<p-calendar inputId="checkoutStartDate" formControlName="checkoutStartDate" (onSelect)="onDateChange()" [style]="{'width':'100%'}">
					</p-calendar>
					<label for="checkoutStartDate">Checkout Start Date</label>
				</span>
			</div>
			<div class="col-lg-6">
				<span class="p-float-label my-2 me-2">
					<p-calendar #checkOutDateCal inputId="checkoutEndDate" formControlName="checkoutEndDate" [style]="{'width':'100%'}" [minDate]="minCheckoutToDate" [defaultDate]="minCheckoutToDate">
					</p-calendar>
					<label for="checkoutEndDate">Checkout End Date</label>
				</span>
			</div>
			<div class="col-lg-6">
				<span class="p-float-label my-2 me-2">
					<p-calendar inputId="occupyingStartDate" formControlName="occupyingStartDate" (onSelect)="onDateChange()" [style]="{'width':'100%'}">
					</p-calendar>
					<label for="occupyingStartDate">Occupying Start Date</label>
				</span>
			</div>
			<div class="col-lg-6">
				<span class="p-float-label my-2 me-2">
					<p-calendar #checkOutDateCal inputId="occupyingEndDate" formControlName="occupyingEndDate" [style]="{'width':'100%'}" [minDate]="minOccupyingToDate" [defaultDate]="minOccupyingToDate">
					</p-calendar>
					<label for="occupyingEndDate">Occupying End Date</label>
				</span>
			</div>
			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2 d-block">
					<!-- <p-dropdown class="w-100 dropdownClr" [options]="reservationStatuses" formControlName="reservationStatus" optionLabel="name"
							 optionValue="value" placeholder=""></p-dropdown>
							<label for="reservationStatus">Status</label> -->

					<p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="reservationStatuses" formControlName="reservationStatus" defaultLabel="Status" optionValue="value"
						id="reservationStatus" optionLabel="name" display="chip">
					</p-multiSelect>
					<label for="shortTermRentalIds">Status</label>
				</span>
			</div>
			<div class="col-lg-12">
				<span class="p-float-label required-field my-2 me-2">
					<p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="reservationTypes" formControlName="reservationType" defaultLabel="name" optionValue="value"
						id="reservationType" optionLabel="name" display="chip">
					</p-multiSelect>
					<label for="reservationType">Reservation Type</label>
				</span>
			</div>
			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2 d-block">
					<p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="shortTermRentals" formControlName="shortTermRentalIds" defaultLabel="Select Property"
						optionValue="shortTermRentalId" id="shortTermRentalIds" optionLabel="propertyCode" display="chip">
					</p-multiSelect>
					<label for="shortTermRentalIds">Select Property</label>
				</span>
			</div>
			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2 required-field">
					<input formControlName="lastName" id="lastName" type="text" pInputText>
					<label for="lastName">Guest Last Name</label>
				</span>
			</div>
			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2 required-field">
					<input formControlName="emailAddress" id="emailAddress" type="text" pInputText>
					<label for="emailAddress">Guest Email</label>
				</span>
			</div>
			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2 required-field">
					<input formControlName="wildcardSearch" id="wildcardSearch" type="text" pInputText>
					<label for="wildcardSearch">Wildcard Seacrh</label>
				</span>
			</div>

		</div>
	</div>
	<hr>
	<div class="row m-0">
		<div class="col-lg-12">
			<div class="btn-group">
				<div class="button-group">
					<button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
					<button pButton class="p-button-text" type="button" (click)="clearForm()">Clear</button>
					<button pButton class="btn-addt p-button" (click)="formSubmit()">Search</button>
				</div>
			</div>
		</div>
	</div>
</div>